import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { tabSlice } from '../reducers/viewData/tabs';
import TabFactory from '../components/tabs/TabFactory';
import { setPageName } from '../reducers/pageSlice';

function ViewData({ tabId, rowId }) {
  const dispatch = useDispatch();
  useEffect(() => {
    if (tabId) {
      dispatch(tabSlice.actions.setTab({ id: tabId, props: { rowId } }));
    }
    dispatch(setPageName('View Data'));
  }, []);
  return <TabFactory slice={tabSlice} />;
}

export default ViewData;
